import { createStructuredSelector } from "reselect";
import {
    SUPPLIER_COM_INFRA_SUPPLIER,
    SUPPLIER_COM_INFRA_SUPPLIER_SUCCESS,
    SUPPLIER_COM_INFRA_SUPPLIER_ERROR,
    SUPPLIER_COM_INFRA_TYPE,
    SUPPLIER_COM_INFRA_TYPE_SUCCESS,
    SUPPLIER_COM_INFRA_TYPE_ERROR,


    SUPPLIER_COM_INFRA_PO,
    SUPPLIER_COM_INFRA_PO_SUCCESS,
    SUPPLIER_COM_INFRA_PO_ERROR,
    SUPPLIER_COM_INFRA_CATEGORY,
    SUPPLIER_COM_INFRA_CATEGORY_SUCCESS,
    SUPPLIER_COM_INFRA_CATEGORY_ERROR,
    SUPPLIER_COMMUNICATION_INFRA_LIST,
    SUPPLIER_COMMUNICATION_INFRA_LIST_SUCCESS,
    SUPPLIER_COMMUNICATION_INFRA_LIST_ERROR,
    SUPPLIER_COMMUNICATION_INFRA_SEARCH_CHANGE,
    SUPPLIER_COMMUNICATION_INFRA_PAGE_SET,
    SUPPLIER_COMMUNICATION_INFRA_ADD_MODAL_SET,
    SUPPLIER_COMMUNICATION_INFRA_ADD_SET_DATA,
    SUPPLIER_COMMUNICATION_INFRA_ADD_CHANGE_SET,
    SUPPLIER_COMMUNICATION_INFRA_ADD,
    SUPPLIER_COMMUNICATION_INFRA_ADD_SUCCESS,
    SUPPLIER_COMMUNICATION_INFRA_ADD_ERROR,
    SUPPLIER_COMMUNICATION_INFRA_EDIT_MODAL_SET,
    SUPPLIER_COMMUNICATION_INFRA_EDIT_SET_DATA,
    SUPPLIER_COMMUNICATION_INFRA_EDIT_CHANGE_SET,
    SUPPLIER_COMMUNICATION_INFRA_EDIT,
    SUPPLIER_COMMUNICATION_INFRA_EDIT_SUCCESS,
    SUPPLIER_COMMUNICATION_INFRA_EDIT_ERROR,
    SUPPLIER_COMMUNICATION_INFRA_UPLOAD_SET,
    SUPPLIER_COMMUNICATION_INFRA_UPLOAD_SET_SUCCESS,
    SUPPLIER_COMMUNICATION_INFRA_UPLOAD_SET_ERROR,
    SUPPLIER_COMMUNICATION_INFRA_UPLOAD_RESET,
    SUPPLIER_COMMUNICATION_INFRA_SEE_MODAL_SET,
    SUPPLIER_COMMUNICATION_INFRA_SEE_SET_DATA,
} from "../../actions";

export const NAME = 'supplierCommunicationInfra';

export const SupplierComInfraSupplier = (data) => ({
    type: SUPPLIER_COM_INFRA_SUPPLIER,
    payload: data
});

export const SupplierComInfraSupplierSuccess = (data) => ({
    type: SUPPLIER_COM_INFRA_SUPPLIER_SUCCESS,
    payload: data
});

export const SupplierComInfraSupplierError = (error) => ({
    type: SUPPLIER_COM_INFRA_SUPPLIER_ERROR,
    payload: error
});

export const SupplierComInfraType = (data) => ({
    type: SUPPLIER_COM_INFRA_TYPE,
    payload: data
});

export const SupplierComInfraTypeSuccess = (data) => ({
    type: SUPPLIER_COM_INFRA_TYPE_SUCCESS,
    payload: data
});

export const SupplierComInfraTypeError = (error) => ({
    type: SUPPLIER_COM_INFRA_TYPE_ERROR,
    payload: error
});






export const SupplierCommunicationInfraList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const SupplierCommunicationInfraListSuccess = (data) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_LIST_SUCCESS,
    payload: data
});

export const SupplierCommunicationInfraListError = (error) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_LIST_ERROR,
    payload: error
});

export const SupplierCommunicationInfraPageSet = (data) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_PAGE_SET,
    payload: data
});

export const SupplierCommunicationInfraSearchChange = (data) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_SEARCH_CHANGE,
    payload: data
});

export const SupplierCommunicationInfraAddModalSet = (data) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_ADD_MODAL_SET,
    payload: data
});

export const SupplierCommunicationInfraAddSetData = (data) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_ADD_SET_DATA,
    payload: data
});


export const SupplierCommunicationInfraAddChangeSet = (data) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_ADD_CHANGE_SET,
    payload: data
});

export const SupplierCommunicationInfraAdd = (page, num_page, orderBy, filters, data) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_ADD,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const SupplierCommunicationInfraAddSuccess = (message) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_ADD_SUCCESS,
    payload: message
});

export const SupplierCommunicationInfraAddError = (error) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_ADD_ERROR,
    payload: error
});

export const SupplierCommunicationInfraEditModalSet = (data) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_EDIT_MODAL_SET,
    payload: data
});

export const SupplierCommunicationInfraEditSetData = (data) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_EDIT_SET_DATA,
    payload: data
});


export const SupplierCommunicationInfraEditChangeSet = (data) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_EDIT_CHANGE_SET,
    payload: data
});

export const SupplierCommunicationInfraEdit = (page, num_page, orderBy, filters, data) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_EDIT,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const SupplierCommunicationInfraEditSuccess = (message) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_EDIT_SUCCESS,
    payload: message
});

export const SupplierCommunicationInfraEditError = (error) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_EDIT_ERROR,
    payload: error
});
export const SupplierCommunicationInfraUploadSet = (file) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_UPLOAD_SET,
    payload: { file },
});

export const SupplierCommunicationInfraUploadSetSuccess = (items) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_UPLOAD_SET_SUCCESS,
    payload: items,
});

export const SupplierCommunicationInfraUploadSetError = (error) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_UPLOAD_SET_ERROR,
    payload: error,
});

export const SupplierCommunicationInfraUploadReset = () => ({
    type: SUPPLIER_COMMUNICATION_INFRA_UPLOAD_RESET
});

export const SupplierCommunicationInfraSeeModalSet = (data) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_SEE_MODAL_SET,
    payload: data
});

export const SupplierCommunicationInfraSeeSetData = (data) => ({
    type: SUPPLIER_COMMUNICATION_INFRA_SEE_SET_DATA,
    payload: data
});

const supplierCommunicationInfra = (state) => state[NAME];

export const SupplierCommunicationInfraSelector = createStructuredSelector({
    supplierCommunicationInfra
})